import { Box, Typography } from "@mui/material";
import I18n from "i18next";
import { MzTabContext, MzTab, MzTabList, MzTabPanel } from "@markaaz/ui/MzTabControls";
import MonitoringReportGrid from "./MonitoringReportGrid";
import ReportActivityHistory from "../ReportActivityHistory";

const sx = {
  title: {
    color: "darkBlue.c100",
    marginBottom: "40px",
    pl: "10px"
  }
};

function MonitoringReportsMain({
  data,
  pagination,
  closeHistoryDialogHandler,
  historyData,
  historyError,
  historyDialogOpen,
  reportName,
  historyPageNo,
  selectedTab,
  onDownload,
  onHistoryClick,
  onChange,
  onHistoryPageChange
}) {
  return (
    <Box>
      <Typography variant="h4" sx={sx.title}>
        {I18n.t("reports.monitoringReports")}
      </Typography>
      <Box sx={{ "> div:first-child": { ml: "10px" } }}>
        <MzTabContext value={selectedTab}>
          <MzTabList onChange={onChange}>
            <MzTab label="Business Monitoring Report" value="1" />
            <MzTab label="Compliance Reports" value="2" />
          </MzTabList>

          <MzTabPanel value="1" sx={{ paddingBottom: 0 }}>
            <MonitoringReportGrid
              rows={data}
              onDownload={onDownload}
              onHistoryClick={onHistoryClick}
              pagination={pagination}
            />
          </MzTabPanel>

          <MzTabPanel value="2" sx={{ paddingBottom: 0 }}>
            <MonitoringReportGrid
              rows={data}
              onDownload={onDownload}
              onHistoryClick={onHistoryClick}
              pagination={pagination}
            />
          </MzTabPanel>
        </MzTabContext>
      </Box>
      <Box>
        {historyDialogOpen && (
          <ReportActivityHistory
            isOpen={historyDialogOpen}
            reportName={reportName}
            historyData={historyData}
            onClose={closeHistoryDialogHandler}
            onHistoryPageChange={onHistoryPageChange}
            historyPageNo={historyPageNo}
            historyError={historyError}
          />
        )}
      </Box>
    </Box>
  );
}

export default MonitoringReportsMain;
